export default (
  state = { vendors: [], isLoading: false, error: null },
  action
) => {
  switch (action.type) {
    case 'FETCH_GET_VENDORS':
      return { ...state, isLoading: true }
    case 'FETCH_GET_VENDORS_SUCCESS':
      const vendors = action.payload.data.map(vendor => vendor.id)

      return {
        ...state,
        isLoading: false,
        vendors
      }
    case 'FETCH_SEARCH_FAIL':
      return { ...state, isLoading: false, error: action.error }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/reducer.js